import { Form, Button } from 'antd';
import { useEffect, useState } from 'react';

export const FormSubmitButton = ({
  form, children, className, loading, disabled = false, onClick = () => { }, id, style,
}) => {
  const [submittable, setSubmittable] = useState(disabled);
  // Watch all values
  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => {
        setSubmittable(true);
      })
      .catch((e) => {
        // 如果没校验通过，且不是第一次的时候，就设置为false
        if (form.isFieldsTouched()) {
          setSubmittable(false);
          console.log('catch', e);
        }
      });
  }, [form, values]);

  return (
    <Button
      className={`bg-[#645aff] ${className} `}
      disabled={!submittable || disabled}
      htmlType="submit"
      id={id}
      loading={loading}
      onClick={onClick}
      style={style}
      type="primary"
    >
      {children}
    </Button>
  );
};
